<template>
  <div class="row">
    <div class="col-1 m-0"></div>
    <div class="col-11 m-0 position-relative input-col-10-padding">
        <select
            id="objectives-select-container"
            class="custom-select-option"
            :value="selected"
            @change="this.$emit('update:selected', $event.target.value)"
            required>
          <option value="" disabled selected>{{ placeholder }}</option>
          <option v-for="obj in data"
                  :key="obj.id"
                  :value="obj.id">
            {{ $t(obj.name.split('.')[1]) }}
          </option>
        </select>
<!--      <label for="objectives-select-container" class="arrow-select position-absolute"><img src="/assets/images/dropdown-select.svg"></label>-->
    </div>
  </div>

</template>

<script lang="ts">
import {defineComponent} from "vue";
import './optionSelect.scss';

export default defineComponent({
  name: 'OptionSelectComponent',
  components: {},
  emits: ['update:selected'],
  props: {
    data: {
      type: Array<{}>
    },
    selected: [Number, String],
    placeholder: {
      type: String
    }

  },

  data() {
    return {

    };
  },

  methods: {

  },

  created() {

  }
})
</script>
